{
  "appointment-card": {
    "buttons": {
      "details": "Details"
    },
    "text": {
      "and-more": "und {{nr}} mehr",
      "cancelled": "ABGESAGT",
      "minutes": "Minuten"
    }
  }
}
